import { useEffect, useRef } from 'react';

const useEffectOnlyOnUpdate = (callback: () => void, dependencies: unknown[] = []) => {
	const didMount = useRef(false);

	useEffect(() => {
		if (didMount.current) {
			callback();
		} else {
			didMount.current = true;
		}
	}, dependencies);
};

export default useEffectOnlyOnUpdate;
